import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { getAllProjects } from "../../services/ValitanApiService";

import RadialChart from "./RadialChart";

const CategoryChartCard = () => {
  const [categoryCounts, setCategoryCounts] = useState({});
  const [total, setTotal] = useState(0);

  useEffect(() => {
    fetchCategoryData();
  }, []);

  const fetchCategoryData = async () => {
    try {
      let allProjects = [];
      let page = 0;
      const size = 100;
      let hasMore = true;

      while (hasMore) {
        const response = await getAllProjects(page, size);

        // ✅ if APIClient already throws toast on error, only null-check here
        if (!response?.data?.content) break;

        const content = response.data.content;
        allProjects = [...allProjects, ...content];
        hasMore = content.length === size;
        page++;
      }

      const grouped = allProjects.reduce((acc, project) => {
        const category = project.project_category?.name || "Uncategorized";
        acc[category] = (acc[category] || 0) + 1;
        return acc;
      }, {});

      setCategoryCounts(grouped);
      setTotal(allProjects.length);
    } catch (error) {
      // ❌ no need to enqueueSnackbar here → global handler in apiClient will handle it
      console.error("Category data fetch error:", error);
    }
  };

  const series = Object.values(categoryCounts);
  const labels = Object.keys(categoryCounts);

  const colors = ["#099680", "#4aa3ff", "#5664d2", "#fd7e14", "#e83e8c", "#6f42c1"];
  const iconList = [
    "ri-building-line",
    "ri-home-gear-line",
    "ri-road-map-line",
    "ri-bank-line",
    "ri-map-pin-line",
    "ri-hospital-line",
  ];

  return (
    <Col xl={4}>
      <Card>
        <CardBody>
          <div className="d-flex align-items-center">
            <div className="flex-grow-1">
              <h5 className="card-title">Project Categories</h5>
            </div>
            <div className="flex-shrink-0">
              <span className="badge bg-primary">{total} total</span>
            </div>
          </div>

          <RadialChart series={series} labels={labels} total={total} colors={colors} />

          <Row>
            {labels.map((name, index) => (
              <div key={name} className="col-4">
                <div className="social-source text-center mt-3">
                  <div className="avatar-xs mx-auto mb-3">
                    <span
                      className="avatar-title rounded-circle font-size-18"
                      style={{
                        backgroundColor: colors[index % colors.length],
                        color: "#fff",
                      }}
                    >
                      <i className={`${iconList[index % iconList.length]}`}></i>
                    </span>
                  </div>
                  <h5 className="font-size-15">{name}</h5>
                  <p className="text-muted mb-0">{categoryCounts[name]} projects</p>
                </div>
              </div>
            ))}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CategoryChartCard;
